/* eslint-disable react-hooks/exhaustive-deps */
import { Menu } from 'antd';
import classes from './SectionMenu.module.scss';
import { useEffect, useState, useRef } from 'react';
import { getNewActiveKey } from '../view/utils';
import GlobalViewAction from './GlobalViewAction';

const SectionMenu = (props) => {
  const { menuItems = [] } = props;

  const scrollref = useRef(null);
  const [showLeftButton, setshowLeftButton] = useState(true);
  const [showRightButton, setshowRightButton] = useState(true);
  const [activeKey, setActiveKey] = useState(menuItems[0]?.key || '');

  useEffect(() => {
    updateScrollButtons();
    const currentReff = scrollref.current;
    if (currentReff) {
      currentReff.addEventListener('scroll', updateScrollButtons);
    }
    return () => {
      if (currentReff) {
        currentReff.removeEventListener('scroll', updateScrollButtons);
      }
    };
  }, []);

  useEffect(() => {
    handleScrollView();
    window.addEventListener('scroll', handleScrollView);
    return () => window.removeEventListener('scroll', handleScrollView);
  }, [activeKey]);
  const handleScrollView = () => {
    const newActiveKey = getNewActiveKey(menuItems, activeKey);
    if (newActiveKey !== activeKey) {
      setActiveKey(newActiveKey);
    }
  };
  const scrollfun = (dir) => {
    if (scrollref.current) {
      const scrollAmount = dir === 'left' ? -500 : 500;
      scrollref.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const updateScrollButtons = () => {
    const { scrollLeft, scrollWidth, clientWidth } = scrollref.current;
    if (scrollref.current) {
      setshowLeftButton(scrollLeft > 0);
      setshowRightButton(scrollLeft < scrollWidth - clientWidth - 1.2);
    }
  };

  return (
    <>
      <div className='section-container'>
        <div className='d-flex flex-column w-100'>
          <GlobalViewAction />
          {/* scrolling Section menu */}
          <div className='d-flex w-100 m-0 p-0 '>
            <div>
              {showLeftButton && (
                <i
                  className='icon icon__chevron-blue left left-arrow mt-3'
                  onClick={() => scrollfun('left')}></i>
              )}
            </div>{' '}
            <div
              ref={scrollref}
              className='scroll-container '>
              <Menu
                mode='horizontal'
                className={`${classes['menuContainer']} left-sections animate__animated animate__fadeIn`}
                selectedKeys={[activeKey]}
                disabledOverflow={true}
                items={menuItems}></Menu>
            </div>
            <div>
              {showRightButton && (
                <i
                  className='icon icon__chevron-blue right left-arrow mt-3 '
                  onClick={() => scrollfun('right')}></i>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionMenu;
